(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["google-reviews"] && !Shopify.designMode) return;
  try {
    


jQuery("#google-reviews").googlePlaces({
	//placeId: 'ChIJdV6Qf3QMZ0gRATRNqPm28vk', //Find placeID @: https://developers.google.com/places/place-id
	placeId: 'ChIJdQXZiGAOZ0gRVFLNhyizT0o',
	render: ['reviews'],
	min_rating: 4,
	max_rows: 4
});



  } catch(e) { console.error(e); }
})();
})();
